import React from 'react';
import makeLazyComponent from 'app/components/layout/LazyLoadingComponent';
const CallTabbar = makeLazyComponent(() => import('app/components/call/CallTabbar'));
import { GetCallBreakpoint } from 'app/containers/call/CallBreakpoint';
import { CALL_BAR_TOP } from 'app/models/ui/call/constants';

const GlobalCallTabbar = () =>
  <GetCallBreakpoint>{({ bar } = {}) =>
    bar === CALL_BAR_TOP && <CallTabbar />
  }</GetCallBreakpoint>
;

export default GlobalCallTabbar;
